define('plugin/push-notifications/model/PushMessageModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Push message Model
     *
     * @class PwaDeviceModel
     */
    return BaseModel.extend({

        url: '/push/message/',

        defaults: {
            'id' : null,
            'hash': null,
            'message': '',
            'title': '',
            'type': 'message',
        },

        initialize: function () {
            this.url = this.url + '?' + jQuery.param({
                id: this.get('id'),
                hash: this.get('hash'),
                type: this.get('type'),
            });

            this.on('sync', this._onModelSync);

            BaseModel.prototype.initialize.call(this);
        },

        _onModelSync : function (){

        }
    });

});
